<template>
  <div class="contractUs">
    <div class="contentBox">
      <span class="conTitle">Contact Us</span>
      <div class="aboutBox">
        <div class="aboutItem">
          <img class="aboutImg" src="@/assets/address.png" alt="" />
          <p class="aboutContent">
            Address: Unit A3, 2/F, Hing Yip Centre, No.31 Hing Yip Street, Kwun
            Tong, Kowloon, Hong Kong
          </p>
        </div>
        <div class="aboutItem">
          <img class="aboutImg" src="@/assets/tel.png" alt="" />
          <p class="aboutContent">Phone: (+86) 18665310015;</p>
        </div>
        <div class="aboutItem">
          <img class="aboutImg" src="@/assets/email.png" alt="" />
          <p class="aboutContent">Email: vincent@voyage-com.com</p>
        </div>
        <div class="qrCode">
          <div class="aboutItemCode">
            <img class="aboutImg" src="@/assets/whiteWechat.png" alt="" />
            <p class="aboutContent">WeChat:</p>
            <img class="wechatImg" src="@/assets/wechatCode1.png" alt="" />
          </div>
          <div class="aboutItemCode">
            <img class="aboutImg" src="@/assets/whiteWhatApp.png" alt="" />
            <p class="aboutContent">WahtApp:</p>
            <img class="wechatImg" src="@/assets/wechatCode.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.contractUs {
  height: 740px;
  width: 100%;
  background-color: #f6f6f6;
  .contentBox {
    padding: 20px 0;
    margin: 0 auto;
    width: 1150px;

    .conTitle {
      font-size: 28px;
      font-weight: 700;
      border-bottom: 4px solid #0057b8;
      padding-bottom: 10px;
      color: #0057b8;
    }
    .aboutBox {
      margin-top: 50px;
      background-color: #fff;
      padding: 20px;
      background-color: #fff;
      border-radius: 20px;
      box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
      .aboutItem {
        display: flex;
        margin-bottom: 40px;
        align-items: center;
        .aboutImg {
          height: 25px;
          width: 25px;
          margin-right: 20px;
        }
        .aboutContent {
          font-size: 24px;
          color: #333333;
        }
      }
      .qrCode {
        display: none;
        .aboutItemCode {
          display: flex;
          margin-bottom: 40px;
          align-items: center;
          .aboutImg {
            height: 25px;
            width: 25px;
            margin-right: 20px;
          }
          .aboutContent {
            font-size: 24px;
            color: #333333;
          }
          .wechatImg {
            height: 100px;
            width: 100px;
          }
        }
      }
    }
  }
  //当屏幕最小宽度为1300px
  @media screen and (min-width: 1300px) {
    .contentBox {
      transition: width 0.3s ease-in-out;
    }
  }
  //当屏幕宽度 最小为1000px 最大为1300px时
  @media screen and (min-width: 1000px) and (max-width: 1300px) {
    .contentBox {
      width: 90%;
      transition: width 0.3s ease-in-out;
    }
  }
  //当屏幕宽度 最小为800px 最大为1000px时
  @media screen and (min-width: 800px) and (max-width: 1000px) {
    .contentBox {
      width: 90%;
      transition: width 0.3s ease-in-out;
    }
  }
  //当屏幕最大宽度为800px
  @media screen and (max-width: 800px) {
    .contentBox {
      width: 90%;
      transition: width 0.3s ease-in-out;
      .conTitle {
        font-size: 16px;
        border-bottom: 2px solid #0057b8;
      }
      .aboutBox {
        border-radius: 10px;
        .aboutItem {
          .aboutContent {
            font-size: 16px;
          }
        }
        .qrCode {
          display: block;
          .aboutItemCode {
            .aboutContent {
              font-size: 16px;
            }
          }
        }
      }
    }
  }
}
</style>
